import {makeGetDevicesByType} from "../selectors/deviceSelector";
import DevType from "@wesstron/utils/Api/constants/devTypes";
import {getRFIDPigHistory} from "../IOT/device-functions/GatewayFunctions";
import {UniqAnimalKey} from "../reducers/rfidHistoryReducer";

export const getPigHistory = (animal) => {
    return (dispatch, getState) => {
        const state = getState();
        const getDevicesByType = makeGetDevicesByType();
        const gateways = getDevicesByType(state, { DevType: [DevType.GATEWAY] });
        const meta = {
            [UniqAnimalKey]: animal[UniqAnimalKey]
        }
        dispatch({
            type: "GET_PIG_HISTORY",
            meta,
            payload: Promise.allSettled(gateways.map((gateway) => {
                return new Promise((onSuccess, reject) => {
                    const onFailure = () => reject(new Error("Could not get pig history"));
                    getRFIDPigHistory(gateway, meta, onSuccess, onFailure);
                })
            }))
        })
    }
}
